export default "__VITE_PUBLIC_ASSET__f92ec032__"